<script setup>
  defineOptions({
  name: 'ScvcepProtocolLink'
});
</script>

<template>
  <a
    href="https://clinicalgenome.org/docs/guidelines-for-applying-for-variant-or-gene-curation-expert-panel-status/"
    target="scvcep-protocol"
  >
    <slot>SC-VCEP Protocol</slot>
  </a>
</template>
